import styled, { css } from "styled-components";

import {
  BorderWrapper,
  DefaultShellWrapper,
} from "@FillInTableContainer/shared/styles/shell.style";

export const ShellWrapper = styled(DefaultShellWrapper)<{
  width: string;
  maxWidth?: string;
}>`
  width: ${({ width }) => width};
  min-width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  height: 100%;
  flex: 1;
`;

export const ShellBorderWrapper = styled(BorderWrapper)<{
  $isTextEvent?: boolean;
}>`
  padding: 0;
  height: 100%;
  background-color: #f0f2f4;
  border: 1px solid #f0f2f4;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;

  ${({ $isTextEvent }) => {
    return (
      !$isTextEvent &&
      css`
        & .text-field-copy-button {
          display: none;
        }
        & .delete-value-button {
          display: none;
        }
      `
    );
  }}

  ${({ isFocused }) =>
    isFocused &&
    css`
      border-radius: var(--Border-Radius-0, 0rem);
      outline: 1px solid var(--Color-Common-Border-Interactive-Primary, #0198e9);
      background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #e6f6ff);
      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12),
        0px 1px 2px 0px rgba(0, 0, 0, 0.16);

      .filled-text-field {
        border: 1px solid
          var(--Color-Common-Border-Interactive-Primary, #0198e9);
        background: var(--Color-Common-Bg-Primary, #fff);
      }
      .empty-text-field {
        border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
        background: var(--Color-Common-Bg-Primary, #fff);
      }
    `}

  & .deal-la-sc-rights-scope-shell-value-wrapper {
    height: 100%;
  }

  & .deal-la-sc-rights-scope-text-field-wrapper {
    height: 100%;
  }
  & .deal-la-sc-rights-scope-text-field {
    border: none;
    border-radius: 0;
    height: 100%;
    padding: 0;
    justify-content: flex-start;

    & textarea {
      height: 100%;
    }
  }

  & .deal-la-sc-rights-scope-textarea-wrapper {
    height: 100%;
  }

  & .deal-la-sc-rights-scope-textarea {
    height: 100%;
    padding: 0.6rem 0.8rem;
  }

  & .deal-la-sc-rights-scope-table-text-field-drag-divider {
    display: none;
  }

  & .deal-la-sc-rights-scope-text-field-input-wrapper {
    height: 100%;
  }

  & .text-field-copy-button {
    display: none;
  }
  & .delete-value-button {
    display: none;
  }
`;

export const DisabledShellBorderWrapper = styled.div`
  display: flex;
  height: 100%;
  background-color: #cbd0d8;
  border: 1px solid #f0f2f4;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  cursor: not-allowed;

  color: var(--Color-Common-Text-Secondary, #515c6c);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;

  padding: 0.4rem 0.4rem;
`;

export const ClickableShellBorderWrapper = styled.div<{
  $isModified: boolean;
  $isPlaceholder: boolean;
}>`
  display: flex;
  height: 100%;
  background-color: #f0f2f4;
  border: 1px solid #f0f2f4;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  cursor: pointer;

  color: var(--Color-Common-Text-Secondary, #515c6c);
  text-align: left;
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;

  padding: 0.4rem 0.8rem;

  ${({ $isModified }) =>
    !$isModified &&
    css`
      color: #11ac45;
    `}

  ${({ $isPlaceholder }) =>
    $isPlaceholder &&
    css`
      color: var(--Color-Common-Text-Tertiary, #7c899c);
    `}
`;
